import React from 'react';
import { SaveType } from '@tencent/mega-sdk-protocols';
import { IModal, IMqq } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { ErrorNoticeAction, LoadErrorNotice, SaveErrorNotice } from '../core/error/convert-error-notice';
import { ConvertStage, IConvertErrorModal, IConvertErrorModalOptions } from '../core/interfaces/convert-error-modal.interface';
import i18n from '@i18next/i18n';
import { showDclReport } from '@src/js/common/ark-extensions/dc-components/dcl-report';

export class ConvertErrorModal implements IConvertErrorModal {
    public constructor(private modal: IModal, private mqq: IMqq) {}

    public show<Stage extends ConvertStage>({
        stage,
        error,
        retry,
    }: IConvertErrorModalOptions<Stage>): void {
        const notice = stage === ConvertStage.Load ? LoadErrorNotice(error) : SaveErrorNotice(error);
        const { action, description } = notice;

        const options = ({
            [ErrorNoticeAction.Upgrade]: {
                onOk: () => this.mqq.invoke('docx', 'checkUpdate'),
                okText: i18n.t('检查更新...'),
                cancelText: i18n.t('取消'),
            },
            [ErrorNoticeAction.CloseTab]: {
                onOk: () => this.mqq.invoke('ui', 'closeTab'),
                okText: i18n.t('关闭'),
                cancelText: null,
            },
            [ErrorNoticeAction.SaveAs]: {
                onOk: () => {
                    retry?.(SaveType.SaveAs);
                },
                okText: i18n.t('另存为...'),
                cancelText: i18n.t('取消'),
            },
            [ErrorNoticeAction.Retry]: {
                onOk: () => {
                    retry?.();
                },
                okText: i18n.t('重试'),
                cancelText: i18n.t('取消'),
            },
            /**
             * 移动端本地编辑新增tbs兜底仅查看
             */
            [ErrorNoticeAction.ReadOnly]: {
                onOk: () => this.mqq.invoke('docx', 'openLocalFileUseTbsOrWKWebView', {
                    errorCode: error.code,
                    errorMsg: error.message,
                }),
                okText: i18n.t('仅查看'),
                cancelText: i18n.t('取消'),
            },
            [ErrorNoticeAction.Feedback]: {
                onOk: () => {
                    showDclReport({
                        clientInfo: window.navigator.userAgent,
                        customInfo: window.location.href,
                    }, true);
                    return false as const;
                },
                okText: i18n.t('反馈'),
                cancelText: i18n.t('取消'),
            },
        })[action];

        this.modal.confirm({
            title: stage === ConvertStage.Load ? i18n.t('无法打开') : i18n.t('保存提示'),
            content: (
                <div style={{ whiteSpace: 'pre-wrap', overflow: 'auto' }}>
                    {`${description}。 ${error.code ? `(${error.code})` : ''}`}
                </div>
            ),
            closable: false,
            zIndex: 10003,
            ...options,
        });
    }
}
